<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.ggtqw">
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:18px;font-family:宋体;">葛根提取物</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;">
            <span style="font-size:12px;">葛根黄酮</span>
          </span>
        </b>
        <b>
          <span style="font-size:12px;font-family:Arial;">70%</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="white-space:normal;">
        <u>
          <span style="font-size:12px;font-family:Arial;">Spec</span>
        </u>
        <span
          style="font-size:12px;font-family:Arial;"
        >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </p>
      <p style="white-space:normal;">
        <span
          style="font-size:12px;font-family:Arial;"
        >Appearance:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Light Brown Yellow Powder&nbsp;</span>
        <span style="font-size:12px;line-height:1.5;"></span>
      </p>

      <p></p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Odror:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Characteristic</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Taste:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Characteristic</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Particle Size:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 100% through 80 mesh</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Assay:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Isoflavones NLT 70%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Extraction Solvent:</span>
          <span></span>
          <span style="font-size:12px;">Ethanol &amp; Water</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Solvent Residue:&nbsp;&nbsp;&nbsp; &lt;0.01%</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Carrier Used:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; None</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Loss on Drying&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;5%</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >Ash:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;5%</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Heavy Metals:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;10 ppm</span>
      </p>
      <p>
        <span style="font-size:12pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >Arsenic(As):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt; 5ppm</span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >Lead(Pb):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;0.5ppm</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >Cadmium(Cd):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;0.5ppm</span>
          <span>
            <span style="font-size:12px;">&nbsp;</span>
            <br>
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span></span>
          <span
            style="font-size:12px;"
          >Mercury(Hg):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt; 0.2ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Microbiology:</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Total
            Plate Count
          </span>
          <span></span>
          <span style="font-size:12px;">:&nbsp;&nbsp;&nbsp; NMT 1000cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Yeast
            &amp; Mold
          </span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; NMT 100cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            E.
            coil
          </span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Salmonellae</span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Pseudomonas: Negative</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <b>
          <span style="font-size:12px;font-family:宋体;">葛根黄酮</span>
        </b>
        <b>
          <span style="font-size:12px;font-family:Arial;">40%</span>
        </b>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Spec</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Appearance:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Light Brown Yellow
            Powder
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Plant Part Used:&nbsp;&nbsp;&nbsp; Root</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Odror:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Characteristic</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Taste:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Characteristic</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Particle Size:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 100% through 80 mesh</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Assay:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Isoflavones NLT 40%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Extraction Solvent:</span>
          <span></span>
          <span style="font-size:12px;">Ethanol &amp; Water</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Solvent Residue:&nbsp;&nbsp;&nbsp; &lt;0.01%</span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Carrier Used:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; None</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Loss on Drying&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;5%</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >Ash:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;5%</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Heavy Metals:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;10 ppm</span>
      </p>
      <p>
        <span style="font-size:12pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >Arsenic(As):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;0.5ppm</span>
          <span>
            <span style="font-size:12px;">&nbsp;&nbsp;</span>
            <br>
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span></span>
          <span
            style="font-size:12px;"
          >Lead(Pb):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;0.5ppm</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12pt;font-family:Arial;">
          <span style="font-size:12px;">Cadmium(Cd):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;0.5ppm</span>
          <span>
            <span style="font-size:12px;">&nbsp;</span>
            <br>
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span></span>
          <span
            style="font-size:12px;"
          >Mercury(Hg):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; None</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Microbiology:</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Total
            Plate Count
          </span>
          <span></span>
          <span style="font-size:12px;">:&nbsp;&nbsp; NMT 1000cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Yeast
            &amp; Mold
          </span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; NMT 100cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            E.
            coil
          </span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Salmonellae</span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Pseudomonas</span>
          <span></span>
          <span style="font-size:12px;">:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative</span>
        </span>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;"></span>
          </span>
        </u>
        <span style="font-size:12px;">&nbsp;</span>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Packing</span>
        </u>
        <span style="font-size:12px;font-family:Arial;">: 25kg per drum</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        ggtqw: require("../../../assets/img/common/ggtqw.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/ggtqw.vue